import { render, staticRenderFns } from "./BoardArticleWebpart.vue?vue&type=template&id=73f4bc53"
import script from "./BoardArticleWebpart.ts?vue&type=script&lang=ts&external"
export * from "./BoardArticleWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports